import React from 'react';
import { SendCondition } from '@spike/form-model';
import { FORM_SEND_CONDITION_COPY } from 'model/Forms';
import { Radio } from 'components/UI/V3/Forms/Radio';
import styles from './FormSendingRules.module.scss';

interface Props {
    value?: string;
    disabled?: boolean;
    onChange: (value: SendCondition) => void;
}

const OPTIONS: SendCondition[] = [SendCondition.FirstBooking, SendCondition.EveryBooking, SendCondition.Manually];

export const FormSendingRules: React.FC<Props> = ({ value, disabled, onChange }) => {
    const selected = value || SendCondition.Manually;

    return (
        <div className={styles.section}>
            <h3 className={styles.title}>When should this form be sent?</h3>
            <p className={styles.description}>Choose when the client should sign this agreement.</p>
            <div className={styles.grid}>
                {OPTIONS.map(option => {
                    const copy = FORM_SEND_CONDITION_COPY[option];
                    const isSelected = selected === option;

                    return (
                        <button
                            key={option}
                            type="button"
                            className={`${styles.card} ${isSelected ? styles.selected : ''}`}
                            disabled={disabled}
                            onClick={() => onChange(option)}
                        >
                            <Radio
                                checked={isSelected}
                                className={styles.radio}
                            />
                            <span className={styles.copy}>
                                <span className={styles.cardTitle}>{copy.title}</span>
                                <span className={styles.cardDescription}>{copy.description}</span>
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default FormSendingRules;
